import { FormGroup, Validators, FormControl } from '@angular/forms';
import { StudentService } from 'src/app/_services/student.service';
import { Student } from 'src/app/_models/student';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-email-form',
  templateUrl: './email-form.component.html',
  styleUrls: ['./email-form.component.css']
})
export class EmailFormComponent implements OnInit {
@Output() closeModalRequest= new EventEmitter<any>()
@Output() submitEmailEvent= new EventEmitter<string>()
  myForm;
  constructor(private studentService:StudentService) { }

  ngOnInit(): void {
    this.myForm = new FormGroup({
      email: new FormControl("", Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)]))
    });
  }
  get f() {
    return this.myForm.controls
  }
  on_submit() {
   this.submitEmailEvent.emit(this.myForm.value.email)
   this.closeModal()
  }
  closeModal(){
     this.closeModalRequest.emit("trialEnrolModal")
  }
}
